import { Controller } from "@hotwired/stimulus"

// The Singur / Împreună / Noi switch on the pricing section (shared/_pricing).
//
// Every offer's content is server-rendered; this only shows the one matching
// the picked offer. Elements tagged `data-pricing-offer-show="singur impreuna"`
// (a space-separated list) are toggled, registration links get the matching
// `?oferta=` URL from `data-<offer>-href`, and legacy checkout forms get the
// matching Stripe lookup_key from `data-<offer>-key`. "impreuna" is the default,
// so without JS the quarterly prices stay visible (PricingHelper::DEFAULT_OFFER).
export default class extends Controller {
  static targets = ["option", "signupLink", "lookupKey"]
  static values = { offer: { type: String, default: "impreuna" } }

  select(event) {
    this.offerValue = event.currentTarget.dataset.offer
  }

  offerValueChanged() {
    const offer = this.offerValue

    // Both switches (pills under `lg`, the list above) are option targets;
    // their active styles hang off `aria-pressed:` variants in the markup.
    this.optionTargets.forEach((option) => {
      option.setAttribute("aria-pressed", option.dataset.offer === offer)
    })

    this.element.querySelectorAll("[data-pricing-offer-show]").forEach((el) => {
      const offers = el.dataset.pricingOfferShow.split(/\s+/)
      el.classList.toggle("hidden", !offers.includes(offer))
    })

    this.signupLinkTargets.forEach((link) => {
      const href = link.dataset[`${offer}Href`]
      if (href) link.href = href
    })

    this.lookupKeyTargets.forEach((input) => {
      const key = input.dataset[`${offer}Key`]
      if (key) input.value = key
    })
  }
}
